export const mapToAddressField = quoteAddress => {
  return quoteAddress
    ? {
        address: quoteAddress?.addressLine1,
        aptNumber: quoteAddress?.addressLine2,
        city: quoteAddress?.city,
        state: quoteAddress?.state,
        zip: quoteAddress?.zipCode,
        latitude: quoteAddress?.latitude,
        longitude: quoteAddress?.longitude,
      }
    : null;
};

export const mapFromAddressField = addressFieldAddress => {
  return {
    addressLine1: addressFieldAddress?.address,
    addressLine2: addressFieldAddress?.aptNumber,
    city: addressFieldAddress?.city,
    state: addressFieldAddress?.state,
    zipCode: addressFieldAddress?.zip,
    latitude: addressFieldAddress?.latitude,
    longitude: addressFieldAddress?.longitude,
  };
};

export const addressToString = address => {
    const  addressLine1 = (address.addressLine1 || "").trim();
    const addressLine2  = (address.addressLine2 || "").trim();
    const city = address.city || "";
    const state = address.state || "";
    const zipCode = address.zipCode || "";

    return `${addressLine1} ${addressLine2}, ${city}, ${state} ${zipCode}`;
}